import React from 'react';
import {State} from 'react-router';
import PopOver from 'rawr/controls/PopOver';
import Contact from 'rawr/controls/Contact';
import ResponsiveElement from 'rawr/layout/ResponsiveElementMixin';
import Icon from 'rawr/style/Icon';
import { logout } from 'rawr/utils/auth';
import notify from 'rawr/notify';
import isPreAPOrSpringboardSlug from 'utils/slug';

import HelpLinks from './HelpLinks';
import FAQ from './FAQ';

import './TopBar.scss';
import 'rawr/layout/base.scss';

// Imported here, but referenced in base.html for all apps
import 'favicon.ico';

export default React.createClass({
    mixins: [ResponsiveElement, State],
    propTypes: {
        home: React.PropTypes.object,
        app: React.PropTypes.object,
        loading: React.PropTypes.bool,
    },
    breakpoints: {
        small: e => e.width < 710,
    },
    getDefaultProps() {
        return {
            home: {label: 'Home', href: '/n/', icon: 'home'}
        };
    },
    getInitialState(){
        return {
            breakpoints: {},
            popover: {
              close: true
            }
        };
    },
    closePopover(bool) {
      /** Set close state for popover conditionally */
      this.setState({
        popover: {
          close: bool || false
        }
      });
    },
    topBarDefaultLayout(loggedIn) {
        const homeUrl = loggedIn && current_user.pilot === 'current2016' ? this.props.home.href : window.current_user.service_base_url;
        let tools = [
            {
                "title": "Groups App",
                "path": "/n/groups#/"
            },
            {
                "title": "Reports App",
                "path": "/n/reports#/"
            },
            {
                "title": "Content Manager",
                "path": "/n/content"
            },
            {
                "title": "PL Content Editor",
                "path": `/n/pl/editor#/editor/ushistory`
            },
            {
                "title": "Component Reference",
                "path": "/n/components#/"
            },
        ];

        return (
            <div className="top_bar_nav top_bar_nav_left">
                <a className="link_home left" href="http://www.collegeboard.org">
                    {cbLogo}
                </a>
                {loggedIn && current_user.pilot === 'current2016' ? (
                        <a className="link_app btn btn--color_blue btn--size_medium" href={homeUrl}>
                            {this.props.home.icon ? <Icon size="1em" name={this.props.home.icon}/> : null}
                            <span className="btn_text btn_text_hidden">{this.props.home.label}</span>
                        </a>
                    ) : null }
                {this.props.app ? (
                        <a className="link_app btn btn--color_blue btn--size_medium" href={this.props.app.href}>
                            {this.props.app.icon ? <Icon size="1em" name={this.props.app.icon}/> : null}
                            <span className="btn_text">{this.props.app.label}</span>
                        </a>
                    ) : null}
                {loggedIn && current_user.show_tools ? (
                        <PopOver width="medium" label="Tools">
                            <ul className="menu user_menu">
                                {tools.map(function (tool, index) {
                                    return <li key={index}><a href={tool.path}>{tool.title}</a></li>
                                })}
                            </ul>
                        </PopOver>
                    ) : null}
            </div>
        );
    },
    topBarSmallLayout(loggedIn) {
        return (
            <div className="top_bar_nav top_bar_nav_small">
                <PopOver label={<Icon name="wide_menu" size="1em"/>} className="top_bar_nav_left">
                    <ul className="top_bar_app_nav">
                        {loggedIn ? (
                                <li>
                                    <a href={this.props.home.href}>
                                        {this.props.home.icon ? <Icon size="1em" name={this.props.home.icon}/> : null}
                                        {this.props.home.label}
                                    </a>
                                </li>
                            ) : null }
                        {this.props.app ? (
                                <li>
                                    <a href={this.props.app.href}>
                                        {this.props.app.icon ? <Icon size="1em" name={this.props.app.icon}/> : null}
                                        {this.props.app.label}
                                    </a>
                                </li>
                            ) : null}
                    </ul>
                </PopOver>
                <a className="link_home" href="http://www.collegeboard.org">
                    {cbLogo}
                </a>
            </div>
        );
    },
    render() {
        const {home, app, loading, params } = this.props;
        const { adminSubjects } = window.current_user;
        let isAPAdmin = false;
        let isPreAPCoord = false;
        const PreAP = 'PRE-AP';
        const AP = 'AP';
        const navigationParams = this.getParams();
        const course = navigationParams && (navigationParams.course || navigationParams.slug);
        const isPreApSubject = course ? isPreAPOrSpringboardSlug(course) : undefined;
        const showAPLinks = course === undefined || isPreApSubject === false ? true : false;

        if (adminSubjects) {
            isAPAdmin = adminSubjects.some(subject => (subject.subjectProgram === AP));
            if (window.current_user.is_coordinator) {
                isPreAPCoord = adminSubjects.some(subject => (subject.subjectProgram === PreAP));
            }
        }
        const { is_coordinator: isCoordinator } = window.current_user;
        const loggedIn = current_user && !current_user.anonymous;

        let layout;
        // Only show the small top bar to non-pilot users
        if (this.state.breakpoints.small && current_user.pilot === 'current2016') {
            layout = this.topBarSmallLayout(loggedIn);
        } else {
            layout = this.topBarDefaultLayout(loggedIn);
        }

        const isImpersonating = window.localStorage.getItem("old_access_token");
        const name = (isImpersonating ? 'Impersonating: ' : '') + current_user.first_name;

        const helpLabel = (
            <span tabIndex={0}>
                <Icon name="circle_help" size="2rem"/>
                <span className="btn_text btn_text_hidden">Help</span>
            </span>
        );

        const userMenuLabel = (
            <span>
                <Icon name="user" size="2rem"/>
                <span className="btn_text btn_text_hidden">{name}</span>
            </span>
        );

        const isAdminOrCoordinator = window.current_user.is_admin || isCoordinator;
        const mySubjectsUrl = isAdminOrCoordinator ? `${window.current_user.service_base_url}/admin` : `${window.current_user.service_base_url}/subjects/preview`;
        const isP2User = window.current_user.pilot === 'p2_2018_08';
        const myClassesUrl = isAdminOrCoordinator ? `${ROS_FRONTEND_URL}/dashboard` :
          (isP2User ? `${window.current_user.service_base_url}/courses` : `${window.current_user.service_base_url}/classes`);
        const accountUrl = isP2User ? `${ROS_PROFILE_URL}?DURL=${window.current_user.service_base_url}` : config.url.account;
        return (
            <div className="top_bar_wrapper">
                <header className="top_bar">
                    { layout }

                    <div className="top_bar_nav top_bar_nav_right">
                        <PopOver
                            close={this.state.popover.close}
                            width={(isPreAPCoord || isAPAdmin || isCoordinator) ? 'wide' : 'medium'}
                            label={helpLabel}
                            className="help_menu_wrapper">
                            <div>
                                <FAQ />
                                { showAPLinks &&
                                    <HelpLinks
                                        isStudent={current_user.isStudent}
                                        user={current_user}
                                        params={params}
                                    />
                                }
                                <h4>Contact Us</h4>
                                <Contact closePopover={this.closePopover} user={current_user} className="user_help_req"/>
                            </div>
                        </PopOver>

                        {loggedIn ? (
                                <PopOver width="auto" label={userMenuLabel} className="user_menu_wrapper">
                                    <ul className="menu user_menu">
                                        <li><a href={accountUrl}>My Account</a></li>
                                        <li>
                                            <a href={`${ROS_FRONTEND_URL}`}>AP Central</a>
                                        </li>
                                        {isAdminOrCoordinator && current_user.pilot !== 'current2016' &&
                                            <li><a href={mySubjectsUrl}>My Courses</a></li>
                                        }
                                        <li><a href={myClassesUrl}>My Classes</a></li>
                                        <li><a href="javascript:;" onClick={logout}>Sign Out</a></li>
                                    </ul>
                                </PopOver>
                            ) : null}
                    </div>
                </header>
                <div className="top_bar_spacer"></div>
            </div>
        );
    }
});

const cbLogo = (
    <svg height="100%" viewBox="0 0 295 82" role="img">
        <title>College Board Logo and Wordmark</title>
        <path
            d="M81.7 41.3l-4.5 0c0 -3.6 -2.5 -5.8 -6 -5.8c-5.3 0 -6.9 4.8 -6.9 9.5c0 4.6 2.2 8.3 7.2 8.3c2.9 0 5.3 -2.1 5.4 -5.2l4.8 0c-0.1 6.6 -5.7 8.7 -10.4 8.7c-8.3 0 -12.3 -5.3 -12.3 -12.2c0 -7.2 3.7 -12.5 11.3 -12.5c2.8 0 5.2 0.8 6.8 3.2l0.1 0.1l0 -2.8l4.5 0l0 8.7Z"/>
        <path
            d="M101.1 47.8c0 5.6 -3.7 9 -9.1 9c-5.3 0 -9.1 -3.3 -9.1 -9c0 -5.6 3.7 -9 9.1 -9c5.4 0 9.1 3.3 9.1 9M92.1 53.3c3.1 0 4.1 -2.9 4.1 -5.5c0 -2.7 -1 -5.5 -4.1 -5.5c-3.1 0 -4.1 2.9 -4.1 5.5c0 2.7 1 5.5 4.1 5.5"/>
        <path d="M101.3 53l2.3 0l0 -17.7l-2.3 0l0 -3.2l7.1 0l0 20.9l2.4 0l0 3.3l-9.5 0l0 -3.3Z"/>
        <path d="M112.5 53l2.4 0l0 -17.7l-2.4 0l0 -3.2l7.2 0l0 20.9l2.4 0l0 3.3l-9.6 0l0 -3.3Z"/>
        <path
            d="M127.6 49.2c0 2.7 1.6 4.3 4.2 4.3c1.7 0 2.9 -0.7 3.3 -2.5l4.5 0c-0.8 4.1 -4.1 5.8 -8 5.8c-5.9 0 -9.1 -3.5 -9.1 -9.2c0 -5.3 3.6 -8.8 9 -8.8c4.1 0 7.4 2.4 8.1 6.5c0.2 1.3 0.2 2.6 0.2 3.8l-12.2 0l0 0.1ZM135.1 46.1c0 -2.4 -1.2 -4 -3.7 -4c-2.4 0 -3.8 1.7 -3.8 4l7.5 0Z"/>
        <path
            d="M161.8 42.6l-2.4 0l0 12.1c0 4.3 -2.2 8.2 -9 8.2c-5 0 -7.6 -1.6 -7.9 -5.6l5.3 0c0.1 2.1 1.6 2.4 3.1 2.4c2.1 0 3.7 -2.1 3.7 -4.2l0 -1.9c-1.6 1.7 -2.7 2.5 -5.7 2.5c-4.6 0 -7.2 -3.9 -7.2 -8.2c0 -5 2.3 -8.9 7.7 -8.9c2.7 0 4.4 1.3 5.5 3l0.1 0l0 -2.6l6.7 0l0 3.2l0.1 0ZM150.8 52.6c3 0 4.1 -2.4 4.1 -5.1c0 -2.6 -1.1 -5.1 -4.1 -5.1c-3 0 -4.2 2.6 -4.2 5.3c0.1 2.5 1.5 4.9 4.2 4.9"/>
        <path
            d="M167.4 49.2c0 2.7 1.6 4.3 4.2 4.3c1.7 0 2.9 -0.7 3.3 -2.5l4.5 0c-0.8 4.1 -4.1 5.8 -8 5.8c-5.9 0 -9.1 -3.5 -9.1 -9.2c0 -5.3 3.6 -8.8 9 -8.8c4.1 0 7.4 2.4 8.1 6.5c0.2 1.3 0.2 2.6 0.2 3.8l-12.2 0l0 0.1ZM174.9 46.1c0 -2.4 -1.2 -4 -3.7 -4c-2.4 0 -3.8 1.7 -3.8 4l7.5 0Z"/>
        <path
            d="M180.7 52.8l3 0l0 -16.8l-3 0l0 -3.4l11.4 0c4.3 0 9.4 0.1 9.4 5.8c0 3.1 -1.6 5 -4.8 5.4l0 0.1c3 0.1 5.6 2.4 5.6 5.5c0 7.1 -6.6 6.9 -10.3 6.9l-11.1 0l0 -3.5l-0.2 0ZM188.7 42.5l2.9 0c2.4 0 4.9 -0.5 4.9 -3.4c0 -2.9 -2.6 -3 -4.8 -3l-3 0l0 6.4ZM188.7 52.8l3.3 0c3.1 0 5.2 -0.5 5.2 -3.7c0 -3.4 -2.6 -3.4 -5.1 -3.4l-3.4 0l0 7.1Z"/>
        <path
            d="M221.1 47.8c0 5.6 -3.7 9 -9.1 9c-5.3 0 -9 -3.3 -9 -9c0 -5.6 3.7 -9 9 -9c5.4 0 9.1 3.3 9.1 9M212.1 53.3c3.1 0 4.1 -2.9 4.1 -5.5c0 -2.7 -1 -5.5 -4.1 -5.5c-3.1 0 -4 2.9 -4 5.5c-0.1 2.7 0.9 5.5 4 5.5"/>
        <path
            d="M234 53.8c-1.6 2.3 -3.1 3 -5.7 3c-3.1 0 -5.9 -1.8 -5.9 -5.4c0 -5.6 5.6 -5.7 9.8 -5.7l1.7 0l0 -1.3c0 -2 -1.5 -2.6 -3.3 -2.6c-1.9 0 -3 0.8 -3.2 2.8l-4.4 0c0.3 -4.8 4.3 -5.6 8.2 -5.6c5.5 0 7.2 2.3 7.2 7.4l0 6.6l2.2 0l0 3.3l-6.6 0l0 -2.5ZM231.6 48.5c-2.5 0 -4.7 0.4 -4.7 2.7c0 1.6 1.1 2.3 2.6 2.3c2.9 0 4.5 -2.1 4.4 -5l-2.3 0Z"/>
        <path
            d="M242.4 53l2.3 0l0 -10.4l-2.3 0l0 -3.3l6.8 0l0 3.3l0.1 0c1 -2.2 2.7 -3.8 5.2 -3.8c0.7 0 1.4 0.1 2.1 0.2l0 4c-0.7 -0.2 -1.5 -0.2 -2.2 -0.2c-3.2 0 -4.7 2.4 -4.9 5.3l0 4.9l2.9 0l0 3.3l-10.1 0l0 -3.3l0.1 0Z"/>
        <path
            d="M274.4 52.8l2.4 0l0 3.3l-6.7 0l0 -2.8l-0.1 0c-1.5 2.4 -3 3.3 -6 3.3c-4.9 0 -7.3 -4.2 -7.3 -8.7c0 -6.2 3.2 -9.2 7.6 -9.2c2.9 0 4.4 1.4 5.3 3l0.1 0l0 -6.5l-2.3 0l0 -3.3l7.2 0l0 20.9l-0.2 0ZM269.9 47.4c0 -2.8 -1.2 -5.3 -4.2 -5.3c-3.1 0 -4 2.7 -4 5.5c0 3.7 1.5 5.5 3.6 5.5c3.6 0.1 4.6 -2.1 4.6 -5.7"/>
        <path
            d="M52.5 32.9c-0.5 -2.3 -2.2 -4 -4.5 -4.9c0 0 -1.2 -0.5 -1.9 -0.7c-1 -0.3 -1.9 -0.5 -3 -0.6c-1.4 -0.3 -5.2 -0.6 -5.9 -0.6c-0.2 0 -0.1 -0.2 0 -0.3c0.2 -0.3 0.5 -0.6 0.7 -0.9c0.5 -0.6 0.8 -1.4 1 -2.1c0.2 -0.9 0.3 -1.8 0.2 -2.7c0 -0.3 -0.1 -0.6 -0.2 -1c0 -0.1 -0.1 -0.4 -0.3 -0.5c-0.1 -0.1 -0.4 0 -0.5 0c-0.3 0.1 -0.6 0.2 -0.9 0.4c-1.7 0.9 -3.4 2.1 -4.3 3.8c-0.4 0.7 -0.6 1.4 -0.7 2.1c0 0.2 0 0.4 0 0.6c0 0.1 0 0.3 -0.1 0.4c-0.1 0.2 -0.3 0.2 -0.5 0.2c-0.4 0 -2.5 0.3 -3.2 0.4c-1.6 0.3 -3.2 0.6 -4.7 1.1c-0.6 0.2 -1.1 0.4 -1.7 0.7l-0.1 0c-0.2 0.1 -0.5 0.3 -0.7 0.4l-0.1 0c-0.2 0.2 -0.5 0.3 -0.7 0.5c-0.2 0.1 -0.3 0.3 -0.4 0.4c-0.1 0.1 -0.1 0.1 -0.2 0.2c-0.1 0.1 -0.1 0.1 -0.2 0.2c-0.3 0.3 -0.5 0.7 -0.7 1.1c0 0 0 0.1 -0.1 0.1c-0.1 0.2 -0.1 0.3 -0.2 0.5c0 0.1 -0.1 0.2 -0.1 0.3c0 0.1 0 0.1 -0.1 0.2c-0.1 0.2 -0.1 0.4 -0.2 0.6c-0.1 0.5 -0.1 1 -0.1 1.5l0 0.8c0 0.1 0 0.2 0.1 0.3c0.2 1.3 0.7 2.2 0.7 2.2c0.5 1 1.2 2.3 2.2 3.4c0 0 0.2 0.2 0.2 0.5c0 0.8 0.2 2.5 1 4.6c1.8 5.5 5.6 9.6 8 11.4c0 0 1.2 1 1.7 1.5c0.7 0.6 1.9 1.4 1.9 1.4c0.5 0.3 0.7 0.4 1.4 0.4c0.8 0 1.4 -0.4 1.9 -0.8c0.7 -0.5 3.6 -2.9 3.6 -2.9c3 -2.7 7.9 -7.9 8.4 -15.7c0 -0.3 0.2 -0.5 0.2 -0.5c1 -1.1 1.7 -2.3 2.2 -3.4c0.2 0.2 1.4 -2.3 0.9 -4.6M34.7 24.8c0 -0.4 0.1 -0.7 0.3 -1.1c0.3 -0.8 0.9 -1.6 1.5 -2.3c0.2 -0.2 0.4 -0.4 0.7 -0.6c0.1 -0.1 0.3 -0.2 0.4 -0.1c0.2 0.1 -0.2 1.2 -0.3 1.3c-0.3 0.8 -0.7 1.5 -1.2 2.2c-0.2 0.3 -0.5 0.6 -0.8 0.8c-0.1 0.1 -0.3 0.3 -0.5 0.2c-0.1 0.1 -0.1 -0.3 -0.1 -0.4M48.6 35.9c-0.1 0.1 -0.2 0.4 -0.3 0.5c0 0 -2 3 -1.7 4.7c0.2 1.1 0.8 2.7 -0.7 6.3c-0.9 2 -1.9 4.3 -5.1 8c0 0 -1.1 1.1 -1.6 1.5c0 0 -2.7 2.2 -3.6 2.2c-0.8 0 -1.5 -0.5 -2 -1c-0.4 -0.4 -1.4 -1.5 -1.5 -1.6c-4.8 -6.1 -5 -11 -4.1 -14.5c0.3 -1.1 1.1 -2 1.9 -2.6c1.8 -1.2 4.1 -1.6 4.5 -1.6c0.9 -0.1 1.4 -0.1 2.3 -0.1c0.7 0 1.4 0 2.1 0c0.4 0 0.8 0 1.2 0.1c0.6 0 1.1 0.1 1.7 0.2c0.3 0.1 0.7 0.2 1 0.2c0.2 0 0.6 0 0.6 -0.3c0 0 0 -0.1 0 -0.2c-0.1 -0.3 -0.6 -0.8 -2.6 -1.3c-0.4 -0.1 -0.9 -0.2 -1.4 -0.2c-0.3 0 -0.6 -0.1 -0.9 -0.1c-0.2 0 -0.4 0 -0.6 0l-0.1 0c-0.2 0 -0.4 0 -0.6 0l-0.1 0c-0.2 0 -0.4 0 -0.6 0l-0.6 0c-3.4 0 -6.4 0.4 -6.4 0.4c0 0 -5.4 0.8 -5.4 -3.2c0 -3.9 4.9 -4.8 8.1 -5.2l0.2 0c0.2 0 0.3 0 0.5 -0.1c0.1 0 0.2 0 0.3 0c0.2 0 0.5 0 0.7 -0.1c0.5 0 1.1 -0.1 1.7 -0.1c0.1 0 0.3 0 0.3 0c1.2 0 2.5 0.1 3.7 0.2c0.9 0.1 1.8 0.3 2.7 0.5c4.3 1.1 8.3 3 6.4 7.4"/>
    </svg>
);



/** WEBPACK FOOTER **
 ** collegeboard/client/rawr/controls/TopBar.jsx
 **/